module.exports = __webpack_public_path__ + "static/scale-model-of-american-swedish-institute-in-minneapolis-minnesota-f55d0e6f628663eb353ae9f65c3bc815.png";